import React, {
  // useMemo,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react'
import { pick } from 'lodash-es'
import { Modal } from '@mantine/core'
import clsx from 'clsx'
import { useFetchRemoteData, useTbViewStore, useProjectStore } from '@vt/hooks'
import { WebBasicForm } from '@ow/ditto'
// import { upload } from '@vt/apis/lib-ex/v2/givrali'
import { Button } from '@ow/comps'
import { useTheme } from '@ow/theme'
import widgets from '../../widgets'

// eslint-disable-next-line no-unused-vars
export default forwardRef(({ onSubmit }, ref) => {
  const { themeClass } = useTheme()
  const formRef = useRef(null)
  const [props, setProps] = useState({})
  const [opened, setOpened] = useState(false)
  const [originalData, setOriginalData] = useState()
  const { fetchTbDataById, editorConfig } = useTbViewStore((state) =>
    pick(state, ['fetchTbDataById', 'editorConfig'])
  )

  const { customCompsMap } = useProjectStore((state) =>
    pick(state, ['customCompsMap'])
  )

  const { editorDataDeal, dealopts } = customCompsMap || {}
  const { inlineEdit } = editorConfig || {}

  const fetchRemoteData = useFetchRemoteData()

  const close = () => {
    setOriginalData(null)
    setProps({})
    setOpened(false)
    if (formRef && formRef.current) {
      formRef.current.reset()
    }
  }

  useImperativeHandle(ref, () => {
    return {
      open: (defs, rowData) => {
        let newDefs = { ...defs }
        if ((inlineEdit.opts || {})[defs.slug]) {
          newDefs = { ...defs, ...(inlineEdit.opts || {})[defs.slug] }
        }
        if (dealopts) {
          newDefs = dealopts(newDefs, rowData)
        }
        setProps({ defs: newDefs, rowData })
        setOpened(true)
      },
      close,
    }
  })

  const onConfirm = () => {
    if (formRef && formRef.current) {
      formRef.current.trigger().then((tr) => {
        if (tr && originalData) {
          const obj = formRef.current.getValues()
          let dealObj = { ...obj }
          console.log(editorDataDeal, 'editorDataDeal')
          if (editorDataDeal) {
            dealObj = editorDataDeal(obj)
          }
          onSubmit({ ...dealObj, objectId: originalData.objectId }, () => {
            setOpened(false)
          })
        }
        return null
      })
    }
  }

  console.log(props.defs, 'props.defs')
  useEffect(() => {
    const { rowData } = props

    if (rowData) {
      fetchTbDataById(rowData.objectId).then((res) => {
        setOriginalData(res.originalData)
      })
    } else {
      setOriginalData(null)
    }
  }, [props])

  if (!originalData) {
    return null
  }

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={props.defs && props.defs.title}
      closeOnClickOutside={false}
      size={props.defs?.inlineEditModalWidth || 'xl'}
      styles={{
        title: {
          fontSize: '16px',
          fontWeight: 'bold',
        },
        inner: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        close: {
          outline: 'none',
        },
      }}
    >
      <div className={clsx(themeClass, 'w-full h-full flex flex-col')}>
        <WebBasicForm
          fields={
            props.defs ? [{ ...props.defs, hiddenWhenCreate: false }] : []
          }
          data={originalData}
          // onClickUpload={upload}
          onFetchRemoteData={fetchRemoteData}
          widgets={widgets()}
          ref={formRef}
        />

        <div className="w-full flex gap-2 justify-end">
          <Button
            type="secondary"
            opacityType="sm"
            onClick={() => setOpened(false)}
          >
            取消
          </Button>
          <Button type="primary" onClick={onConfirm}>
            确定
          </Button>
        </div>
      </div>
    </Modal>
  )
})
